import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import allStocks from '../data/stock_us_filtered_sorted.json';
import PubSub from 'pubsub-js';
import { InputGroup } from 'react-bootstrap';

// const custom_sort = (a, b) => {
//   return a.symbol - b.symbol;
// }

export const TypeAHeadNavigate = () => {
  const navigate = useNavigate();
  let location = useLocation();
  let options = allStocks;
  const ref = React.createRef();

  const onChangeStockSelection = data => {
    console.log('navigating to before navigate', data, location);
    if (data !== undefined && data.length >= 1) {

      let url = '/chart/';
      if (data[0].exchangeShortName === 'CRYPTO'){
        url = '/crypto/chart/';
      } else if (data[0].exchangeShortName === 'MUTUAL_FUND'){
        url = '/mutualfund/chart/';
      } else if (data[0].exchangeShortName === 'ETF' || (data[0].type !== undefined && data[0].type === 'etf')){
        url = '/etf/chart/';
      }

      url = url + data[0].symbol;
      console.log('navigating to ', data, url, location);
      PubSub.publish('stockQuoteTypeHead', data);

      //Clear the input
      ref.current.clear();

      //Navigate to Stock Quote
      navigate(url);
    }
  }

  const onKeyDown = event => {
    if (event !== undefined && event.key === 'Enter' && event.target !== undefined && event.target.value !== undefined){
      let value = event.target.value.toUpperCase(); 
      console.log('navigating to after', event.key, value);

      let url = '/chart/';
      for (var i=0; i<options.length; i++){
        if (value === options[i].symbol){
          if (options[i].exchangeShortName === 'CRYPTO'){
            url = '/crypto/chart/';
            break;
          } else if (options[i].exchangeShortName === 'MUTUAL_FUND'){
            url = '/mutualfund/chart/';
            break;
          } else if (options[i].exchangeShortName === 'ETF'|| (options[i].type !== undefined && options[i].type === 'etf')){
            url = '/etf/chart/';
            break;
          }         
        }
      }
      url = url + value;

      if (!value.match(/^[A-Za-z0-9^.]+$/)){
        console.log('Contains invalid character');
        url = '/';
        value = '';
      }

      let tmpObj = {
        symbol: value
      } 
      PubSub.publish('stockQuoteTypeHead', tmpObj);

      //Clear the input
      ref.current.clear();

      //Navigate to Stock Quote
      navigate(url);
    }
  }

  return (
    <InputGroup size="sm" className="mb-3">
      <InputGroup.Text id="basic-addon1">
        <i className="fa fa-search"></i>
      </InputGroup.Text>

      <Typeahead
        id="stock-typeahead-single"
        labelKey="symbol"
        filterBy={['symbol', 'name']}
        clearButton
        ref={ref}
        onChange={(selected) => {
          onChangeStockSelection(selected);
        }}
        onKeyDown={(selected) => {
          onKeyDown(selected);
        }}
        size="small"
        options={options}
        placeholder="Search Ticker or Company"
        renderMenuItemChildren={(option) => (
          <div>
            <small>{option.symbol} - {option.name}</small>
          </div>
        )}
      />
    </InputGroup>
  )
}